import './toolbar.css';

const name = 'd-table-toolbar';

class Toolbar extends HTMLElement {

  connectedCallback () {
    this.classList.add('d-legacy-toolbar', name);
  }

}

customElements.define(name, Toolbar);
